

/* Warning: this file is auto-generated, any changes would be lost */
  
import React, { useEffect } from "react"

import "../src/assets/sass/main.scss"
import "typeface-roboto"

import Layout from "../src/components/layout"
import SEO from "../src/components/seo"

import { connect } from "react-redux"
import { setCorrespondingLangSlug, setToLanguage } from "../src/state/actions"
import { useTranslation } from 'react-i18next';

import Section from "../src/components/section"
import SectionOuter from "../src/components/section-outer"
import GatsbyImage from "gatsby-image"
import SectionInner from "../src/components/section-inner"

// Sections


const Page = ({ setCorrespondingLangSlug, setToLanguage, lang, correspondingLangSlug, pageContext }) => {
  const { i18n } = useTranslation()
  const page = pageContext.page
  
  const pageBuilder = page.pageBuilder.content || []

  const correspondingTranslation = page.translations.find((translation) => {
    return translation.language.locale !== page.language.locale
  })

  useEffect(() => {
    if (page.language.locale !== lang) {
      setToLanguage(page.language.locale)
      i18n.changeLanguage(page.language.locale)
    }

    if (correspondingTranslation && correspondingTranslation.fullSlug !== correspondingLangSlug) {
      setCorrespondingLangSlug(correspondingTranslation.fullSlug)
    }
  })
  return (
    <Layout>
      <SEO title={page.title} lang={page.language.locale}/>
      <Section className="SinglePost">
      <SectionOuter>
      {
         page.featuredImage &&
         <GatsbyImage className="SinglePost-cover" fluid={page.featuredImage.imageFile ? page.featuredImage.imageFile.publicURL : page.featuredImage.sourceUrl} alt={page.featuredImage.altText} />
      }
      </SectionOuter>
      <SectionInner className="SinglePost-inner Section--vPadding u-textMaxWidth">

        <h1 className="SinglePost-title t-h1">{page.title}</h1>

        <div className="SinglePost-body" dangerouslySetInnerHTML={{ __html: page.content }}/>

      </SectionInner>

    </Section>
      
      {
        pageBuilder.map((section, index) => {
          if (!section) {
            return null
          }
        
        
          return <div>In AllComponents fehlt das Mapping der Komponente.</div>

        })

      }
    </Layout>
  )
}


const mapStateToProps = (state) => {
  return {
    lang: state.lang,
    correspondingLangSlug: state.correspondingLangSlug,
  }
}

const mapDispatchToProps = {
  setCorrespondingLangSlug,
  setToLanguage,
}

export default connect(mapStateToProps, mapDispatchToProps)(Page)
